<template>
    <section>
        <!-- Campaign: 2023 December -->
        <!-- <router-link :to="eventResultsLink">
            <picture>
                <source media="(min-width: 992px)" type="image/webp" srcset="/images/events/2023/christmas-sale/landing/banner-desktop@2x.webp">
                <source media="(min-width: 992px)" srcset="/images/events/2023/christmas-sale/landing/banner-desktop@2x.jpg">
                <source srcset="/images/events/2023/christmas-sale/landing/banner-mobile@2x.webp" type="image/webp">
                <img class="img-responsive" srcset="/images/events/2023/christmas-sale/landing/banner-mobile@2x.jpg" style="width:100%" alt="">
            </picture>
        </router-link> -->

        <!-- Background Image -->
        <div class="used-landing__background" ref="usedSearch">
            <div class="used-landing__banner container">
                <!-- Search Box -->
                <div>
                    <div class="used-landing__search-box">
                        <h1 class="used-landing__title">{{ pageTitle }}</h1>

                        <div class="used-landing__input-list">
                            <div>
                                <select class="form-control" :disabled="loading" v-model="manufacturer">
                                    <option disabled>Select Make</option>
                                    <option value>Any Make</option>
                                    <template v-for="option in manufacturers">
                                        <option :value="option.manufacturer" :key="option.manufacturer"
                                            v-if="!paymentSearch">
                                            {{ option.manufacturer }} ({{ option.count }})
                                        </option>
                                        <option :value="option.manufacturer" :key="option.manufacturer" v-else>
                                            {{ option.manufacturer }}
                                        </option>
                                    </template>
                                </select>
                            </div>

                            <div>
                                <select class="form-control" :disabled="loading" v-model="model">
                                    <option disabled>Select Model</option>
                                    <option value>Any Model</option>
                                    <template v-for="option in models">
                                        <option :value="option.model" :key="option.model" v-if="!paymentSearch">
                                            {{ option.model }} ({{ option.count }})
                                        </option>
                                        <option :value="option.model" :key="option.model" v-else>
                                            {{ option.model }}
                                        </option>
                                    </template>
                                </select>
                            </div>

                            <div class="used-landing__input-pills">
                                <div class="used-landing__input-pill">
                                    <input type="radio" v-model="paymentSearch"
                                        :id="`${fullFormIdentifier}-search-by-price`" value="0" autocomplete="off" />
                                    <label :for="`${fullFormIdentifier}-search-by-price`">
                                        <span>Cash</span>
                                    </label>
                                </div>
                                <div class="used-landing__input-pill">
                                    <input type="radio" v-model="paymentSearch"
                                        :id="`${fullFormIdentifier}-search-by-monthly`" value="1" autocomplete="off" />
                                    <label :for="`${fullFormIdentifier}-search-by-monthly`">
                                        <span>Finance</span>
                                    </label>
                                </div>
                            </div>

                            <div v-show="paymentSearch == 0"
                                class="used-landing__input-list used-landing__input-list--two-col">
                                <div class="">
                                    <select class="form-control form-control--min-max" :disabled="loading" v-model="minPrice">
                                        <option disabled>Min. Price</option>
                                        <option value>Any Min. Price</option>
                                        <option v-for="option in minPrices" :value="option.price" :key="option.price"
                                            :disabled="option.disabled">£{{ number_format(option.price) }}</option>
                                    </select>
                                </div>

                                <div class="">
                                    <select class="form-control form-control--min-max" :disabled="loading" v-model="maxPrice">
                                        <option disabled>Max. Price</option>
                                        <option value>Any Max. Price</option>
                                        <option v-for="option in maxPrices" :value="option.price" :key="option.price"
                                            :disabled="option.disabled">£{{ number_format(option.price) }}</option>
                                    </select>
                                </div>
                            </div>

                            <div v-show="paymentSearch == 1" class="used-landing__input-list">
                                <!-- Deposit -->
                                <div class="form-control--price-input">
                                    <span>{{ `${deposit} Deposit` }}</span>
                                    <input type="text" class="form-control" placeholder="Deposit" :disabled="loading"
                                        v-model.number="deposit" />
                                </div>
                                <!-- Term -->
                                <div>
                                    <select class="form-control" :disabled="loading" v-model="term">
                                        <option disabled>Term</option>
                                        <option value="12">12 months</option>
                                        <option value="25">25 months</option>
                                        <option value="31">31 months</option>
                                        <option value="36">36 months</option>
                                        <option value="42">42 months</option>
                                        <option value="48">48 months</option>
                                        <option value="60">60 months</option>
                                    </select>
                                </div>
                                <!-- Annual Mileage -->
                                <div>
                                    <select class="form-control" :disabled="loading" v-model="annualMileage">
                                        <option disabled>Annual Mileage</option>
                                        <option value="6000">6,000 miles per annum</option>
                                        <option value="10000">10,000 miles per annum</option>
                                        <option value="15000">15,000 miles per annum</option>
                                        <option value="20000">20,000 miles per annum</option>
                                    </select>
                                </div>
                            </div>

                            <button class="btn btn--primary btn--full-width" @click.once="search" type="button">
                                Search <span>{{ countFormatted }}</span> Cars
                            </button>
                            <button :class="{
                                'link link--is-button link--centered': true,
                                'link--has-icon-down': !moreOptions,
                                'link--has-icon-up': moreOptions
                            }"
                                @click="toggleMoreOptions">More options</button>

                            <div id="trustpilot" ref="trustpilot" data-locale="en-GB" data-template-id="5419b732fbfb950b10de65e5" data-businessunit-id="55a4b2750000ff00058109a4" data-style-height="24px" data-style-width="100%" data-theme="dark">
                                <a href="https://uk.trustpilot.com/review/www.robinsandday.co.uk" target="_blank" rel="noopener">Trustpilot</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="container advanced-search__card" ref="usedAdvancedSearch" v-show="moreOptions">
            <div class="rd-card rd-card--border-top">
                <!-- 4 column grid -->
                <div class="advanced-search__grid">
                    <div class="advanced-search__grid--span-4 advanced-search__title-wrapper">
                        <h2 class="advanced-search__title">Advanced Search</h2>
                        <p>At Stellantis &You, you’ll find thousands of used Abarth, Citroen, DS, Fiat, Peugeot and Vauxhall cars and vans for sale across our {{ locationCount }} dealerships nationwide.</p>
                    </div>

                    <div class="advanced-search__grid--span-1">
                        <label class="advanced-search__label advanced-search__label--gap" for="manufacturer">Make</label>
                        <select class="advanced-search__input form-control" :disabled="loading" v-model="manufacturer">
                            <option disabled>Select Make</option>
                            <option value>Any Make</option>
                            <template v-for="option in manufacturers">
                                <option :value="option.manufacturer" :key="option.manufacturer" v-if="!paymentSearch">
                                    {{ option.manufacturer }} ({{ option.count }})
                                </option>
                                <option :value="option.manufacturer" :key="option.manufacturer" v-else>
                                    {{ option.manufacturer }}
                                </option>
                            </template>
                        </select>
                    </div>

                    <div class="advanced-search__grid--span-1">
                        <label class="advanced-search__label advanced-search__label--gap" for="model">Model</label>
                        <select class="advanced-search__input form-control" :disabled="loading" v-model="model">
                            <option disabled>Select Model</option>
                            <option value>Any Model</option>
                            <template v-for="option in models">
                                <option :value="option.model" :key="option.model" v-if="!paymentSearch">
                                    {{ option.model }} ({{ option.count }})
                                </option>
                            </template>
                        </select>
                    </div>

                    <div class="advanced-search__grid--span-2 advanced-search__price-grid">
                        <span class="advanced-search__grid--span-2 advanced-search__label">Price</span>
                        <div class="advanced-search__grid--span-1">
                            <div class="advanced-search__input-pills">
                                <div class="advanced-search__input-pill">
                                    <input type="radio" v-model="paymentSearch"
                                        :id="`${fullFormIdentifier}-search-by-price`" value="0" autocomplete="off" />
                                    <label :for="`${fullFormIdentifier}-search-by-price`">
                                        <span>Cash</span>
                                    </label>
                                </div>
                                <div class="advanced-search__input-pill">
                                    <input type="radio" v-model="paymentSearch"
                                        :id="`${fullFormIdentifier}-search-by-monthly`" value="1" autocomplete="off" />
                                    <label :for="`${fullFormIdentifier}-search-by-monthly`">
                                        <span>Finance</span>
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div v-show="paymentSearch == 0"
                            class="advanced-search__grid--span-1 used-landing__input-list used-landing__input-list--two-col">
                            <div class="">
                                <select class="advanced-search__input form-control form-control--min-max" :disabled="loading" v-model="minPrice">
                                    <option disabled>Min. Price</option>
                                    <option value>Any Min. Price</option>
                                    <option v-for="option in minPrices" :value="option.price" :key="option.price"
                                        :disabled="option.disabled">£{{ number_format(option.price) }}</option>
                                </select>
                            </div>

                            <div class="">
                                <select class="advanced-search__input form-control form-control--min-max" :disabled="loading" v-model="maxPrice">
                                    <option disabled>Max. Price</option>
                                    <option value>Any Max. Price</option>
                                    <option v-for="option in maxPrices" :value="option.price" :key="option.price"
                                        :disabled="option.disabled">£{{ number_format(option.price) }}</option>
                                </select>
                            </div>
                        </div>

                        <div v-show="paymentSearch == 1" class="advanced-search__grid--span-1 used-landing__input-list">
                            <!-- Deposit -->
                            <div class="form-control--price-input">
                                <span>{{ `${deposit} Deposit` }}</span>
                                <input type="text" class="advanced-search__input form-control" placeholder="Deposit"
                                :disabled="loading" v-model.number="deposit" />
                            </div>
                            <!-- Term -->
                            <div>
                                <select class="advanced-search__input form-control" :disabled="loading" v-model="term">
                                    <option disabled>Term</option>
                                    <option value="12">12 months</option>
                                    <option value="25">25 months</option>
                                    <option value="31">31 months</option>
                                    <option value="36">36 months</option>
                                    <option value="42">42 months</option>
                                    <option value="48">48 months</option>
                                    <option value="60">60 months</option>
                                </select>
                            </div>
                            <!-- Annual Mileage -->
                            <div>
                                <select class="advanced-search__input form-control" :disabled="loading"
                                    v-model="annualMileage">
                                    <option disabled>Annual Mileage</option>
                                    <option value="6000">6,000 miles per annum</option>
                                    <option value="10000">10,000 miles per annum</option>
                                    <option value="15000">15,000 miles per annum</option>
                                    <option value="20000">20,000 miles per annum</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <div class="advanced-search__grid--span-2 advanced-search__price-grid">
                        <span class="advanced-search__grid--span-2 advanced-search__label">Location</span>
                        <CustomerLocation class="advanced-search__grid--span-1" placeholder="Postcode/Town"
                            v-on:changed="filterDealers" />

                        <div class="advanced-search__grid--span-1">
                            <select class="advanced-search__input form-control" :disabled="loading" v-model="distance">
                                <option disabled>Select a distance</option>
                                <option v-for="option in distances" :value="option" :key="option">
                                    {{ formatDistance(option) }}
                                </option>
                            </select>
                        </div>
                    </div>

                    <div class="advanced-search__grid--span-1">
                        <label class="advanced-search__label advanced-search__label--gap" for="age">Age</label>
                        <select class="advanced-search__input form-control" :disabled="loading" v-model="age">
                            <option disabled>Select an age</option>
                            <option value>Age (any)</option>
                            <option :value="option.age" :key="option.age" v-for="option in ages">
                                Up to {{ option.age }} years
                            </option>
                        </select>
                    </div>

                    <div class="advanced-search__grid--span-1">
                        <label class="advanced-search__label advanced-search__label--gap" for="mileage">Mileage</label>
                        <select class="advanced-search__input form-control" :disabled="loading" v-model="mileage">
                            <option disabled>Select a Mileage</option>
                            <option value>Mileage (any)</option>
                            <option v-for="option in mileages" :value="option" :key="option">
                                {{ wordedMileage(option) }}
                            </option>
                        </select>
                    </div>

                    <div class="advanced-search__grid--span-4">
                        <UsedLandingSearchBoxColourFilter />
                    </div>

                    <div class="advanced-search__grid--span-1">
                        <label class="advanced-search__label advanced-search__label--gap" for="">Vehicle Type</label>
                        <select class="advanced-search__input form-control" :disabled="loading" v-model="carOrVan">
                            <option disabled>Select an option</option>
                            <option value>Car or Van</option>
                            <option value="non-commercial">Car</option>
                            <option value="commercial">Van</option>
                        </select>
                    </div>

                    <div class="advanced-search__grid--span-3">
                        <label class="advanced-search__label advanced-search__label--gap" for="">Body Type</label>
                        <select class="advanced-search__input form-control" :disabled="loading" v-model="body">
                            <option disabled>Select a Body Type</option>
                            <option value>Any Body Type</option>
                            <template v-for="option in bodies">
                                <option :value="option.body" :key="option.body" v-if="!paymentSearch">
                                    {{ option.body }} ({{ option.count }})</option>
                                <option :value="option.body" :key="option.body" v-else>
                                    {{ option.body }}
                                </option>
                            </template>
                        </select>
                    </div>

                    <div class="advanced-search__grid--span-1">
                        <label class="advanced-search__label advanced-search__label--gap" for="">Transmission</label>
                        <select class="advanced-search__input form-control" :disabled="loading" v-model="transmission">
                            <option disabled>Select a Transmission</option>
                            <option value>Transmission (any)</option>
                            <template v-for="option in transmissions">
                                <option :value="option.transmission" :key="option.transmission"
                                    v-if="!paymentSearch">
                                    {{ option.transmission }} ({{ option.count }})
                                </option>
                                <option :value="option.transmission" :key="option.transmission" v-else>
                                    {{ option.transmission }}
                                </option>
                            </template>
                        </select>
                    </div>

                    <div class="advanced-search__grid--span-1">
                        <label class="advanced-search__label advanced-search__label--gap" for="">Fuel type</label>
                        <select class="advanced-search__input form-control" :disabled="loading" v-model="fuelType">
                            <option disabled>Select a fuel type</option>
                            <option value>Fuel type (any)</option>
                            <template v-for="option in fuelTypes">
                                <option :value="option.fuelType" :key="option.fuelType" v-if="!paymentSearch">
                                    {{ option.fuelType }} ({{ option.count }})</option>
                                <option :value="option.fuelType" :key="option.fuelType" v-else>
                                    {{ option.fuelType }}
                                </option>
                            </template>
                        </select>
                    </div>

                    <div class="advanced-search__grid--span-1">
                        <label class="advanced-search__label advanced-search__label--gap" for="">Annual Tax</label>
                        <select class="advanced-search__input form-control" :disabled="loading" v-model="annual_tax">
                            <option disabled>Select an annual tax</option>
                            <option value="">Any annual tax</option>
                            <option v-for="(option, index) in annualTaxes" :value="option.value" :key="index">
                                {{ option.label }}
                            </option>
                        </select>
                    </div>

                    <div class="advanced-search__grid--span-1">
                        <label class="advanced-search__label advanced-search__label--gap" for="">CO2 Emissions</label>
                        <select class="advanced-search__input form-control" :disabled="loading" v-model="emissions">
                            <option disabled>Select a CO2 emission</option>
                            <option value="">Any emissions</option>
                            <option v-for="(option, index) in availableEmissions" :value="option.value" :key="index">
                                {{ option.label }}
                            </option>
                        </select>
                    </div>

                    <div class="advanced-search__grid--span-1">
                        <label class="advanced-search__label advanced-search__label--gap" for="">Registration</label>
                        <input type="text" class="advanced-search__input form-control" v-model="registrationEntered" @blur="registrationBlurEvent" placeholder="Enter reg (if known)" />
                    </div>

                    <div class="advanced-search__grid--span-1">
                        <label class="advanced-search__label advanced-search__label--gap" for="">Keywords</label>
                        <input type="text" class="advanced-search__input form-control" v-model="keywords" placeholder="Enter any keyword" />

                    </div>

                    <div class="advanced-search__checkboxes">
                        <div class="advanced-search__checkbox">
                            <input class="advanced-search__checkbox-input" id="nearly_new" name="nearly_new" type="checkbox"/>
                            <label class="advanced-search__checkbox-label" for="nearly_new">
                                Nearly new cars
                            </label>
                        </div>
                    </div>
                </div>

                <div class="advanced-search__grid advanced-search__card">
                    <div class="advanced-search__grid--span-2 advanced-search__links-left">
                        <button class="btn btn--primary" @click.once="search">
                            Search <span class="">{{ countFormatted }}</span> Cars
                        </button>
                        <button class="link link--is-button" @click="resetForm">Reset Search</button>
                    </div>

                    <div class="advanced-search__grid--offset-3--span-1 advanced-search__links-right">
                        <button class="link link--is-button link--has-secondary-icon-up link--secondary" @click="toggleMoreOptions">Hide Options</button>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import CustomerLocation from "./CustomerLocation";
import numberFormat from "../api/NumberFormat";
import debounce from "lodash/debounce";
import twoWayComputedProperties from "../api/used-search-options/TwoWayComputedProperties";
import getManufacturerFromBrand from '../api/GetManufacturerFromBrand';
import computedArrayStringBinding from '../api/used-search-options/ComputedArrayStringBinding';
import UsedLandingSearchBoxColourFilter from './UsedLandingSearchBoxColourFilter';

export default {
    components: {
        CustomerLocation,
        UsedLandingSearchBoxColourFilter,
    },
    data() {
        return {
            moreOptions: false,
            registrationEntered: "",
        };
    },
    computed: {
        ...mapGetters({
            dealers: "Dealers/dealers",
            distances: "UsedSearchOptions/distances",
            models: "UsedSearchOptions/models",
            manufacturers: "UsedSearchOptions/manufacturers",
            userOptions: "UsedSearchOptions/userOptions",
            loading: "UsedSearchOptions/loading",
            minPriceOption: "UsedSearchOptions/minPrice",
            maxPriceOption: "UsedSearchOptions/maxPrice",
            ages: "UsedSearchOptions/ages",
            fuelTypes: "UsedSearchOptions/fuelTypes",
            numDoorOptions: "UsedSearchOptions/numDoors",
            bodies: "UsedSearchOptions/bodies",
            mileages: "UsedSearchOptions/mileages",
            transmissions: "UsedSearchOptions/transmissions",
            colours: "UsedSearchOptions/colours",
            engineSizes: "UsedSearchOptions/engineSizes",
            nearlyNew: "UsedSearchOptions/nearlyNew",
            // count: 'UsedSearchOptions/count',
        }),
        ...twoWayComputedProperties([
            'paymentSearch',
            'paymentRange',
            'deposit',
            'term',
            'annualMileage',
            'distance',
            'numDoors',
            'body',
            'mileage',
            'colour',
            'engineSize',
            'photo',
            'annual_tax',
            'emissions',
        ]),
        ...computedArrayStringBinding([
            'age',
            'model',
            'carOrVan',
            'transmission',
            'fuelType',
        ]),
        fullFormIdentifier() {
            return "search-by-" + this._uid;
        },
        brand() {
            return this.$route.params.brand || "";
        },
        manufacturer: {
            get() {
                if (typeof this.userOptions.manufacturer == "string") {
                    return this.userOptions.manufacturer;
                }

                if (this.userOptions.manufacturer.length === 0 || this.userOptions.manufacturer[0] === "") {
                    return "";
                }

                return this.userOptions.manufacturer[0];
            },
            set(value) {
                // If we change the manufacturer we need to blank the model, unless we change it to Any
                if (value !== "" && value !== this.userOptions.manufacturer) {
                    this.$store.dispatch("UsedSearchOptions/updateOptions", {
                        manufacturer: [value],
                        model: ""
                    });
                    return;
                }
                this.$store.dispatch("UsedSearchOptions/updateOptions", {
                    manufacturer: [value]
                });
            }
        },
        minPrice: {
            get() {
                if (this.userOptions.minPrice === 0) {
                    return "";
                }
                return this.userOptions.minPrice;
            },
            set(value) {
                if (value >= this.maxPrice) {
                    if (value > this.minPrices[0]) {
                        this.minPrice = this.minPrices[0];
                        return;
                    }
                }
                this.$store.dispatch("UsedSearchOptions/updateOptions", {
                    minPrice: value
                });
            }
        },
        maxPrice: {
            get() {
                if (this.userOptions.maxPrice === 0) {
                    return "";
                }
                return this.userOptions.maxPrice;
            },
            set(value) {
                this.$store.dispatch("UsedSearchOptions/updateOptions", {
                    maxPrice: value
                });
            }
        },
        keywords: {
            get() {
                return this.userOptions.keywords;
            },
            set: debounce(function (value) {
                this.$store.dispatch("UsedSearchOptions/updateOptions", {
                    keywords: value
                });
            }, 500)
        },
        minPrices() {
            let prices = [];
            let i = this.minPriceOption;
            while (i < this.maxPriceOption) {
                prices.push({
                    price: i,
                    disabled:
                        this.maxPrice !== "" && i >= this.maxPrice
                            ? true
                            : false
                });
                i = i < 5000 ? i + 500 : i + 1000;
            }
            return prices;
        },
        maxPrices() {
            let prices = [];
            let i =
                this.minPriceOption < 5000
                    ? Math.ceil(this.minPriceOption / 500) * 500
                    : Math.ceil(this.minPriceOption / 1000) * 1000;
            while (i < this.maxPriceOption) {
                prices.push({
                    price: i,
                    disabled:
                        this.minPrice !== "" && i <= this.minPrice
                            ? true
                            : false
                });
                i = i < 5000 ? i + 500 : i + 1000;
            }
            return prices;
        },
        countFormatted: {
            get() {
                return numberFormat(
                    this.$store.state.UsedSearchOptions.animatedCount
                );
            }
        },
        locationCount() {
            return [...this.$store.state.Dealers.dealers].filter((dealer) => dealer.offers_used == "Y").length;
        },
        annualTaxes() {
            const availableOptions = this.$store.state.UsedSearchOptions.options.annual_tax;
            if (!availableOptions) {
                return [];
            }

            return availableOptions.map(availableOption => {
                if (availableOption > 0) {
                    return {
                        value: availableOption,
                        label: 'Up to £' + number_format(availableOption) + ' Tax'
                    };
                }
                return {
                    value: availableOption,
                    label: '£0 Tax'
                };
            });
        },
        availableEmissions() {
            const availableOptions = this.$store.state.UsedSearchOptions.options.emissions;
            if (!availableOptions) {
                return [];
            }

            return availableOptions.map(availableOption => {
                if (availableOption > 0) {
                    return {
                        value: availableOption,
                        label: 'Up to ' + number_format(availableOption) + ' g/km CO2'
                    };
                }
                return {
                    value: availableOption,
                    label: '0 g/km CO2'
                };
            });
        },
        pageTitle() {
            switch (this.brand) {
                case 'abarth':
                    return 'Used Abarth cars for sale';

                case 'citroen':
                    return 'Used Citroën cars for sale';

                case 'ds':
                    return 'Used DS cars for sale';

                case 'fiat':
                    return 'Used Fiat cars for sale';

                case 'peugeot':
                    return 'Used Peugeot cars for sale';

                case 'vauxhall':
                    return 'Vauxhall Used Cars for Sale';

                case 'jeep':
                    return 'Used Jeep cars for sale';

                case 'alfa-romeo':
                    return 'Used Alfa Romeo cars for sale';

                // case 'leapmotor':
                //     return 'Used Leapmotor cars for sale';

                default:
                    return 'Discover your perfect car';
            }
        },
        // Campaign: 2023 December
        // eventResultsLink() {
        //     if (this.brand != '') {
        //         return {name: 'used-results', params: { resultsType: 'used-vehicles' }, query: {keywords: 'sale-event', manufacturer: getManufacturerFromBrand(this.brand)}}
        //     }

        //     return {name: 'used-results', params: { resultsType: 'used-vehicles' }, query: {keywords: 'sale-event'}}
        // }
    },
    methods: {
        ...mapMutations({
            setUserOptions: "UsedSearchOptions/setUserOptions"
        }),

        toggleMoreOptions() {
            this.moreOptions = !this.moreOptions;
            const openedOrClosed = (this.moreOptions === true) ? 'Opened' : 'Closed';
            this.gaTag('Used Landing', 'More options', openedOrClosed);
            this.$nextTick().then(() => {
                if (this.moreOptions) {
                    const offset = -10;
                    const y = this.$refs.usedAdvancedSearch.getBoundingClientRect().top + window.scrollY + offset;
                    window.scrollTo({
                        top: y,
                        behavior: 'smooth',
                    })
                } else {
                    window.scrollTo({
                        top: 0,
                        behavior: 'smooth',
                    })
                }
            })
        },

        formatDistance(distance) {
            if (distance == -1) {
                return "Any distance";
            }
            return "Within " + numberFormat(distance, 0) + " miles";
        },

        number_format(num) {
            return numberFormat(num);
        },

        wordedAge(age) {
            return age == 1 ? "Up to 1 year" : "Up to " + age + " years";
        },

        wordedMileage(mileage) {
            return "Up to " + numberFormat(mileage, 0) + " miles";
        },

        resetForm: debounce(
            function () {
                this.gaTag('Used Landing', 'Reset Search', 'Clicked');
                this.$store.dispatch('UsedSearchOptions/resetUserOptions');
                if (this.$route.query) {
                    this.$store.commit('UsedSearchOptions/setUserOptions', this.$route.query);
                }
                if (this.$route.params && this.$route.params.brand) {
                    this.$store.commit('UsedSearchOptions/setUserOptions', {
                        manufacturer: getManufacturerFromBrand(this.$route.params.brand)
                    });
                }
                this.$store.dispatch('UsedSearchOptions/updateOptions', {
                    nearlyNew: 0,
                    new: 0,
                });
            },
            1000,
            { leading: true }
        ),
        filterDealers(distance) {
            this.$store.dispatch('UsedSearchOptions/locationUpdated', {
                triggerOptionsUpdate: true,
                updateViaRoute: false
            });
        },
        search() {
            this.gaTag('Used Landing', 'Search', 'Clicked');
            this.$store.dispatch('UsedSearchOptions/setUserOptionsByPushingRoute', this.userOptions);
        },

        registrationBlurEvent() {
            if (this.registrationEntered != this.userOptions.registration) {
                this.$store.dispatch("UsedSearchOptions/updateOptions", {
                    registration: this.registrationEntered
                });
            }
        }
    },
    mounted() {
        if (!window.trustPilotScriptAdded) {
            const s = document.createElement('script');
            s.setAttribute('src', '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js');
            document.body.appendChild(s);
            window.trustPilotScriptAdded = true;
            s.onload = () => {
                window.Trustpilot.loadFromElement(this.$refs['trustpilot']);
            };
            return;
        } else {
            if (window.Trustpilot) {
                window.Trustpilot.loadFromElement(this.$refs['trustpilot']);
            }
        }
        // this.$nextTick().then(() => {
        //     let el = document.getElementById("trustpilot");
        //     window.Trustpilot.loadFromElement(el);
        // });
    },
};
</script>

<style lang="scss">
@import "../../../sass/redesign/variables";

.webp {
    .used-landing {
        &__background {
            @media (max-width: $screen-sm-max) {
                &:after {
                    background-image: url('/images/used/used-vehicles-bg-img.webp');
                }
            }

            @media (min-width: $screen-md) {
                background-image: url('/images/used/used-vehicles-bg-img.webp');
            }
        }
    }
}

.used-landing {
    &__background {
        @media (max-width: $screen-sm-max) {
            position: relative;
            margin-bottom: -32px;
            &:after {
                content: "";
                position: absolute;
                left: 0;
                bottom: 32px;
                width: 100%;
                height: 450px;
                background-image: url('/images/used/used-vehicles-bg-img.jpg');
                background-repeat: no-repeat;
                z-index: -100;
                background-position: center center;
                background-size: cover;
            }
        }

        @media (min-width: $screen-md) {
            background-image: url('/images/used/used-vehicles-bg-img.jpg');
            background-position: 50% 25%;
            background-repeat: no-repeat;
            background-size: cover;
            height: 600px;
        }
    }

    &__banner {
        display: grid;
        grid-template-columns: 1fr;
        grid-template-rows: auto;
        gap: 30px;
        // padding-bottom: 32px;
        padding-bottom: 450px;

        @media (min-width: $screen-md) {
            grid-template-columns: minmax(0, 350px) minmax(0, 1fr);
            grid-template-rows: auto;
            padding-bottom: 64px;
        }
    }

    &__search-box {
        background: $blue-gradient-dark-to-light-vertical;
        padding: 20px;
        border-radius: 0 0 10px 10px;
        color: #fff;
    }

    &__title {
        font-size: 20px;
        line-height: 20px;
        padding: 10px;
        color: #ffffff;
    }

    &__input-list {
        display: grid;
        grid-template-columns: minmax(0, 1fr);
        gap: 10px;

        &--two-col {
            grid-template-columns: repeat(2, minmax(0, 1fr));
        }
    }

    &__input-pills {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        background: #E6F4FB;
        border-radius: 10px;
        gap: 10px;
        padding: 10px;
    }

    &__input-pill {

        input {
            display: none;

            &:checked+label {
                background: $blue;
                color: #fff;
                transition: background 0.2s ease-in-out, color 0.2s ease-in-out;
            }
        }

        label {
            display: block;
            color: #000000;
            background-color: #E6F4FB;
            border-radius: 10px;
            text-align: center;
            padding: 10px 5px;
        }
    }

    &__range-title {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    &__range-slider {
        margin: 10px 15px;

        &.noUi-target {
            height: 8px;
            border: none;
            box-shadow: none;
        }

        .noUi-connect {
            background: $rd-pop-blue;
        }

        .noUi-handle {
            width: 22px;
            height: 22px;
            border: none;
            border-radius: 50%;

            &::before,
            &::after {
                content: none;
            }
        }
    }
}

.advanced-search {
    &__card {
        margin-top: 30px;
    }

    &__grid {
        display: grid;
        grid-template-columns: minmax(0, 1fr);
        gap: 10px;

        @media (min-width: $screen-md) {
            grid-template-columns: repeat(4, minmax(0, 1fr));
        }

        // @for $i from 1 through 3 {
        //     &--offset-#{$i} {
        //         @media (min-width: $screen-md) {
        //             grid-column-start: #{$i + 1};
        //         }

        //         @for $j from 1 through 4 {
        //             &--span-#{$j} {
        //                 @media (min-width: $screen-md) {
        //                     grid-column: #{$i + 1} / span #{$j};
        //                 }
        //             }
        //         }
        //     }
        // }

        &--offset-3--span-1 {
            @media (min-width: $screen-md) {
                grid-column: 4 / span 1;
            }
        }

        @for $i from 1 through 4 {
            &--span-#{$i} {
                @media (min-width: $screen-md) {
                    grid-column: span #{$i};
                }
            }
        }
    }

    &__links-left {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        gap: 30px;
    }

    &__links-right {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        gap: 30px;
    }

    &__price-grid {
        display: grid;
        grid-template-columns: minmax(0, 1fr);
        gap: 10px;

        @media (min-width: $screen-md) {
            grid-template-columns: repeat(2, minmax(0, 1fr));
        }
    }

    &__input {
        background-color: #F7F7F7;
    }

    &__label {
        font-size: 16px;
        font-weight: bold;
        color: $navy-blue;

        &--gap {
            display: block;
            margin-bottom: 10px;
        }
    }

    &__input-grid {
        display: grid;
        grid-template-columns: minmax(0, 1fr);
        gap: 10px;
    }

    &__checkboxes {
        display: flex;
        flex-direction: row;
        justify-content: left;
        align-items: center;
        gap: 10px;
        margin-top: 28px;
    }

    &__checkbox {
        display: flex;
        flex-direction: row;
        justify-content: start;
        align-items: center;
        gap: 10px;

        &-label {
            cursor: pointer;
            color: $orange-price;
            font-weight: bold;
        }

        &-input {
            appearance: none;
            cursor: pointer;
            height: 24px;
            width: 24px;
            border: 1px solid $orange-price;
            border-radius: 6px;
            transition: all 150ms ease-in-out;

            &:checked {
                border: unset;
                background-color: $orange-price;
            }
        }
    }

    &__input-pills {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        background: #E6F4FB;
        border-radius: 10px;
        gap: 7px;
        padding: 7px;
    }

    &__input-pill {
        input {
            display: none;

            &:checked+label {
                background: $blue;
                color: #fff;
                transition: background 0.2s ease-in-out, color 0.2s ease-in-out;
            }
        }

        label {
            display: block;
            color: #000000;
            background-color: #E6F4FB;
            border-radius: 10px;
            text-align: center;
            padding: 7.5px 5px;
        }
    }
}

.form-control--price-input {
    position: relative;

    .form-control {
        padding-left: 25px;
    }

    &::before {
        content: "£";
        position: absolute;
        top: 0;
        left: 12px;
        bottom: 0;
        color: #000000;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 16px;
        line-height: 22px;
        pointer-events: none;
    }

    > span {
        position: absolute;
        inset: 0;
        font-size: 16px;
        color: #000000;
        display: flex;
        align-items: center;
        font-weight: 400;
        line-height: 22px;
        pointer-events: none;
        padding: 5px 15px 5px 25px;
    }
}

.form-control--min-max {
    font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/used-vue/components/UsedLandingSearchBox.vue